<template>
  <v-sheet color="alert" class="pa-2" style="width: 132px">
    <div class="d-flex">
      <div class="ma-auto">
        <v-icon color="red" class="mr-2"> $iconBell </v-icon>
      </div>
      <div style="font-size: 10px; text-align: center; align-self: center">
        <slot>{{ $t("events:common.ShowOfficePurchase.badge") }}</slot>
      </div>
    </div>
  </v-sheet>
</template>
<script>
export default {
  name: "AppShowOfficePurchase"
};
</script>
